/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_MembershipInputs */

const en_nav_membership = /** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membership`)
};

const id_nav_membership = /** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keanggotaan`)
};

/** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */
const es_nav_membership = en_nav_membership;

/** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */
const fr_nav_membership = en_nav_membership;

/** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */
const de_nav_membership = en_nav_membership;

/** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */
const ja_nav_membership = en_nav_membership;

/** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */
const zh_nav_membership = en_nav_membership;

/** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */
const ar_nav_membership = en_nav_membership;

/** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */
const it_nav_membership = en_nav_membership;

/** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */
const ru_nav_membership = en_nav_membership;

/** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */
const pt_nav_membership = en_nav_membership;

/** @type {(inputs: Nav_MembershipInputs) => LocalizedString} */
const ko_nav_membership = en_nav_membership;

/**
* | output |
* | --- |
* | "Membership" |
*
* @param {Nav_MembershipInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_membership = /** @type {((inputs?: Nav_MembershipInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_MembershipInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_membership(inputs)
	if (locale === "es") return es_nav_membership(inputs)
	if (locale === "fr") return fr_nav_membership(inputs)
	if (locale === "de") return de_nav_membership(inputs)
	if (locale === "ja") return ja_nav_membership(inputs)
	if (locale === "zh") return zh_nav_membership(inputs)
	if (locale === "ar") return ar_nav_membership(inputs)
	if (locale === "id") return id_nav_membership(inputs)
	if (locale === "it") return it_nav_membership(inputs)
	if (locale === "ru") return ru_nav_membership(inputs)
	if (locale === "pt") return pt_nav_membership(inputs)
	return ko_nav_membership(inputs)
});